import Photo from './Photo';
import Video from './Video';
import Document from './Document';
import BeforeAfter from './BeforeAfter';
import BeforeAfterShare from './BeforeAfterShare';
import MediaSetShare from './MediaSetShare';
import Other from './Other';

export default {
    Photo,
    Video,
    Document,
    BeforeAfter,
    BeforeAfterShare,
    MediaSetShare,
    Other,
};
